import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import consts from '../../util/consts'
import createAsyncConst from '../../util/createAsyncConst'

export const SUBMIT_LAUNDRY_CLIENT_BILLING = createAsyncConst('SUBMIT_LAUNDRY_CLIENT_BILLING')
export const FETCH_LAUNDRY_CLIENT_BILLING = createAsyncConst('FETCH_LAUNDRY_CLIENT_BILLING')
export const EDIT_LAUNDRY_CLIENT_BILLING = createAsyncConst('EDIT_LAUNDRY_CLIENT_BILLING')
export const FETCH_CEP = createAsyncConst('FETCH_CEP')

export function fetchLaundryClients(page, filters = [], rows) {
  return dispatch => {
    dispatch(action(FETCH_LAUNDRY_CLIENT_BILLING.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-client-billing`, {
        params: {
          filters: JSON.stringify(filters),
          rows: rows || consts.DEFAULT_PAGINATION,
          page: page || 1,
        },
      })
      .then(resp => {
        dispatch(action(FETCH_LAUNDRY_CLIENT_BILLING.SUCCESS, resp.data))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_LAUNDRY_CLIENT_BILLING, e)))
  }
}

export function edit(id) {
  return dispatch => {
    dispatch(action(EDIT_LAUNDRY_CLIENT_BILLING.ACTION, { id }))
    return axios
      .get(`${config.API_URL}/laundry-client-billing/${id}`)
      .then(resp => {
        return resp.data.data
      })
      .then(data => dispatch(action(EDIT_LAUNDRY_CLIENT_BILLING.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(EDIT_LAUNDRY_CLIENT_BILLING, e)))
  }
}

export const getFile = async (id) => {
  return axios
      .get(`${config.API_URL}/laundry-client-billing/document/${id}`, {responseType: 'blob'})
      .then(resp => {
        return resp
      })
};

function submit(values, method) {
  const id = values.id ? `/${values.id}` : ''
  return dispatch => {
    dispatch(action(SUBMIT_LAUNDRY_CLIENT_BILLING.ACTION))
    var formData = new FormData();
    values.is_payed = values.is_payed.toString();
    delete values.user;
    delete values.laundry_client;
    
    Object.entries(values).forEach(entry => {
      
      entry[0] == 'file' ? formData.append("file", values.file) : formData.append(entry[0], entry[1]) ;      
    });
    method == 'put' ? formData.append('_method', 'PUT'):''
    return axios['post'](`${config.API_URL}/laundry-client-billing${id}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_LAUNDRY_CLIENT_BILLING.SUCCESS, data))
        dispatch(fetchLaundryClients())
        return data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_LAUNDRY_CLIENT_BILLING, e)))
  }
}

export function post(values) {
  return submit(values, 'post')
}

export function update(values) {
  return submit(values, 'put')
}
